document.addEventListener('DOMContentLoaded', () => {
  const summary = document.querySelector('.js-summary');

  if (!summary) return;

  const indicator = summary.querySelector('.c-summary__indicator');
  const links = summary.querySelectorAll('a[href^="#"]');
  const linkTargets = new Map();
  let observer = null;
  let scheduled = false;
  let isActive = false;

  links.forEach(link => {
    const targetId = link.getAttribute('href').slice(1);
    const targetEl = document.getElementById(targetId);
    if (targetEl && targetEl.tagName.toLowerCase() === 'h2') {
      linkTargets.set(targetEl, link);
    }

    // VoiceOver (iOS Safari) n'exécute pas toujours la navigation native
    // vers l'ancre quand le lien est activé via le geste de validation du
    // lecteur d'écran (le tap tactile direct fonctionne, l'activation
    // VoiceOver non) : on prend donc en charge le scroll et le focus nous-
    // mêmes plutôt que de dépendre du comportement natif du navigateur.
    link.addEventListener('click', (event) => {
      const target = document.getElementById(targetId);
      if (!target) return;

      event.preventDefault();

      if (!target.hasAttribute('tabindex')) {
        target.setAttribute('tabindex', '-1');
      }

      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      target.focus({ preventScroll: true });

      if (window.history && window.history.pushState) {
        window.history.pushState(null, '', `#${targetId}`);
      }
    });
  });

  function updateIndicatorPosition() {
    const current = summary.querySelector('[aria-current="true"]');

    if (!indicator) return;

    if (window.scrollY === 0 || !current) {
      indicator.style.transform = 'translateY(0)';
      indicator.style.height = '0';
      return;
    }

    const summaryRect = summary.getBoundingClientRect();
    const currentRect = current.getBoundingClientRect();
    const offsetY = currentRect.top - summaryRect.top;

    indicator.style.transform = `translateY(${offsetY}px)`;
    indicator.style.height = `${currentRect.height}px`;
  }

  function scheduleIndicatorUpdate() {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(() => {
        updateIndicatorPosition();
        scheduled = false;
      });
    }
  }

  function initObserver() {
    if (observer) observer.disconnect();

    observer = new IntersectionObserver((entries) => {
      const visibleEntries = entries
        .filter(entry => entry.isIntersecting)
        .map(entry => {
          const rect = entry.boundingClientRect;
          const distanceToCenter = Math.abs(
            rect.top + rect.height / 2 - window.innerHeight / 2
          );
          return { entry, distanceToCenter };
        })
        .sort((a, b) => a.distanceToCenter - b.distanceToCenter);

      if (visibleEntries.length > 0) {
        const { entry } = visibleEntries[0];
        const h2 = entry.target;
        const link = linkTargets.get(h2);

        links.forEach(link => {
          const parent = link.parentElement;
          if (parent) parent.removeAttribute('aria-current');
        });

        if (link && link.parentElement) {
          link.parentElement.setAttribute('aria-current', 'true');
        }

        scheduleIndicatorUpdate();
      }
    }, {
      threshold: [0.25]
    });

    linkTargets.forEach((_, h2) => {
      observer.observe(h2);
    });

    window.addEventListener('scroll', scheduleIndicatorUpdate);
    window.addEventListener('resize', handleResize);

    isActive = true;
  }

  function destroyObserver() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    window.removeEventListener('scroll', scheduleIndicatorUpdate);
    window.removeEventListener('resize', handleResize);

    indicator.style.transform = 'translateY(0)';
    indicator.style.height = '0';

    links.forEach(link => {
      const parent = link.parentElement;
      if (parent) parent.removeAttribute('aria-current');
    });

    isActive = false;
  }

  function handleResize() {
    if (window.innerWidth < 960) {
      if (isActive) destroyObserver();
    } else {
      if (!isActive) initObserver();
    }
  }

  if (window.innerWidth >= 960) {
    initObserver();
  }

  window.addEventListener('resize', handleResize);
});
